export default ["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  // Now set up the states
  $stateProvider
    .state('userEdit', {
      parent: "app",
      url: "/user/:id",
      feature: "menu.settings.users",
      executeUserCheck: function canEditUsers(user) {
        return user.effectiveUserObjectPermissions && user.effectiveUserObjectPermissions.userObjectsEdit;
      },
      views: {
        "main": {
          template: require("./eaUserDetailPage/eaUserDetailPageModule.html"),
          controller: "eaUserDetailPageModuleController as $ctrl"
        }
      },
      resolve: {
        ctrl: ["$q", "$ocLazyLoad", ($q, $ocLazyLoad)=> {
          return $q((resolve)=> {
            require.ensure([], ()=> {
              let module = require("./index.js");
              $ocLazyLoad.load({name: module.default});
              resolve();
            });
          });
        }]
      }
    })
    .state("user", {
      parent: "app",
      url: "/user?username",
      feature: "menu.settings.users",
      executeUserCheck: function canReadUsers(user) {
        return user.effectiveUserObjectPermissions && user.effectiveUserObjectPermissions.userObjectsRead;
      },
      views: {
        "main": {
          template: require("./eaUserPage/eaUserPageModule.html"),
          controller: "eaUserPageModuleController as $ctrl"
        }
      },
      resolve: {
        ctrl: ["$q", "$ocLazyLoad", ($q, $ocLazyLoad)=> {
          return $q((resolve)=> {
            require.ensure([], ()=> {
              let module = require("./index.js");
              $ocLazyLoad.load({name: module.default});
              resolve();
            });
          });
        }],
        companyFilterEnabled: ["UserService", (UserService) => {
          return UserService.hasFeature("settingsUserListPage.companyFilterEnabled");
        }]
      }
    });
}];


// WEBPACK FOOTER //
// ./src/ui/modules/eaSettings/eaUser/routes.js